

const _env = ("")  ;
let apiKey = '';
if (_env.NODE_ENV === 'production') {
  // Harden: only use the dedicated production key in production builds.
  apiKey = _env.REACT_APP_GOOGLE_MAPS_API_KEY_PROD || '';
} else {
  // In development, allow either the generic or the dedicated dev key.
  apiKey = _env.REACT_APP_GOOGLE_MAPS_API_KEY || _env.REACT_APP_GOOGLE_MAPS_API_KEY_DEV || '';
}

const GOOGLE_MAPS_CONFIG = {
  apiKey,
  libraries: ['places', 'geometry'],
  defaultZoom: 13,
  deliveryRadiusMeters: 40000,
  stores: {
    HARARE: {
      name: 'Harare',
      // Per request: 69 Baines Avenue, Harare
      address: '69 Baines Avenue, Harare, Zimbabwe',
      // Optional seed center (will be refined by geocoding on mount)
      center: { lat: -17.8292, lng: 31.0522 }
    },
    MUTARE: {
      name: 'Mutare',
      // Per request: 87c Hebert Chitepo Street, Mutare (Manica Post Building)
      address: '87c Hebert Chitepo Street, Mutare (Manica Post Building), Zimbabwe',
      center: { lat: -18.9707, lng: 32.6706 }
    }
  }
};

export const getStoreForCity = (city = 'HARARE') => {
  const key = (city || 'HARARE').toUpperCase();
  return GOOGLE_MAPS_CONFIG.stores[key] || GOOGLE_MAPS_CONFIG.stores.HARARE;
};

export default GOOGLE_MAPS_CONFIG;

